import React from 'react';
import { Button, ListGroup, Modal } from 'react-bootstrap';
import { StyledModal } from './style';

function LogModal({ show, onHide, logs }) {
  return (
    <StyledModal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Command logs</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {
          <ListGroup id="list-wrapper">
            {logs.split('\n').map((log, idx) => (
              <ListGroup.Item
                key={idx}
                variant="success"
                style={{ padding: 0 }}
              >
                <pre style={{ margin: '0' }}>{log}</pre>
              </ListGroup.Item>
            ))}
          </ListGroup>
        }
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </StyledModal>
  );
}

export default LogModal;
